export const API_EXTERNAL_ENDPOINT = 'contact-page'

export const API_INTERNAL_ENDPOINT = 'strapi/contact-page'
